// extracted by mini-css-extract-plugin
export default {"no-search-wrapper":"UBjxAw","noSearchWrapper":"UBjxAw","no-search-icon":"LYzC5W","noSearchIcon":"LYzC5W","no-search-text":"qB_Svp","noSearchText":"qB_Svp"};